import React, {useState, useEffect} from 'react'
import { getTopTopics } from '../../utils/api-services/topic';
import TopicItem from './TopicItem';
import "../../global/components/scroll-bar.css";
import PageLoader from '../../global/components/PageLoader';

const TopTopics = () => {

    const [topics, setTopics] = useState([]);
    const [loading, setLoading] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);
    const isMobile = width <= 768;

    useEffect(()=>{
        loadTopics();
    }, []);

    const loadTopics = async () => {
        setLoading(true);
        const data = await getTopTopics();
        setTopics(data);
        setLoading(false);
    }

    const styles = {
        section:{

        },
        desktop: {
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '1rem'
        },
        mobile: {
            display: 'flex',
            overflowY: 'scroll'
        },
        header:{
            display: 'flex',
        },
        title:{
            fontSize: isMobile? 16: 20,
            fontWeight:500,
            marginBottom: 30
        },
        action:{
            wrap:{
                paddingRight: 0,
                marginLeft: 'auto',
            },
            link:{
                fontSize: isMobile? 15: 18,
                textDecoration: 'none',
            }
        }
    }

    
    const display = (
        <div style={styles.section}>
            <div style={styles.header}>
                <h2 style={styles.title}>Top Topics for You</h2>
                <div style={styles.action.wrap}>
                    <a href={"/topic/list/1"} style={styles.action.link}>Topic Listings</a>
                </div>
            </div>
            <div style={isMobile? styles.mobile: styles.desktop} className='hide-scroll-bar'>
                {topics.map((itm, index) => (
                    <TopicItem key={index} obj={itm} />
                ))}
            </div>
        </div>
    )

    if(loading){
        return <PageLoader top={50} bottom={50} />
    }else{
        return (topics.length > 0) && display;
    }

}

export default TopTopics